import { createStyles } from "@mantine/emotion";

export const useStylesTechnicalDetail = createStyles((theme) => ({
  technical: {
    marginTop: theme.spacing.technicalDetail.margin.top.main,
    ".title": {
      fontFamily: theme.headings.fontFamily.bold,
      color: theme.customColors.blackLight,
      fontSize: theme.spacing.technicalDetail.fontSize.title,
    },
    ".item": {
      maxHeight: theme.spacing.technicalDetail.item.maxHeight,
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        display: "block",
        marginTop: theme.spacing.technicalDetail.margin.top.item,
        maxHeight: "none",
      },
      ".key": {
        fontSize: theme.spacing.technicalDetail.fontSize.key,
        color: theme.customColors.technicalDetailLabel,
        fontFamily: theme.headings.fontFamily.light,
      },
      ".dots": {
        flexGrow: "1",
        borderBottom: theme.customColors.borderDotted,
        bottom: theme.spacing.technicalDetail.position.dots.bottom,
        position: "relative",
        marginLeft: theme.spacing.technicalDetail.margin.left.dots,
        marginRight: theme.spacing.technicalDetail.margin.right.dots,
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          display: "none",
        },
      },
      ".value": {
        fontSize: theme.spacing.technicalDetail.fontSize.value,
        fontFamily: theme.headings.fontFamily.light,
        color: theme.customColors.technicalDetailValue,
        a: {
          color: `${theme.colors.blue[7]} !important`,
          textDecoration: "underline",
          "&:hover": {
            color: `${theme.colors.blue[7]} !important`,
            textDecoration: "none",
          },
          "&:visited": {
            color: `${theme.colors.blue[7]} !important`,
          },
        },
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          marginBottom: theme.spacing.technicalDetail.margin.bottom.value,
        },
      },
      ".value-without-copy": {
        paddingRight: theme.spacing.technicalDetail.padding.value.right,
        [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
          paddingRight: "0",
        },
      },
      "&.download-pdf-item": {
        marginTop: theme.spacing.technicalDetail.margin.top.download,
      },
      ".download-pdf": {
        background: "none",
        border: "0",
        cursor: "pointer",
        fontFamily: theme.headings.fontFamily.light,
        color: theme.customColors.blackLight,
        marginTop: "0",
        padding: "0",
        textDecoration: "underline",
        ":hover": {
          color: theme.customColors.blackLight,
          textDecoration: "none",
        },
      },
    },
    "&.technical-error-display .item": {
      maxHeight: "none",
    },
    ".accordion": {
      margin: "0",
      maxWidth: "none",
    },
    ".stamp-time-details": {
      borderBottom: theme.customColors.technicalDetailDivider,
      marginBottom: theme.spacing.technicalDetail.divider.marginBottom,
      paddingBottom: theme.spacing.technicalDetail.divider.paddingBottom,
      ".item:not(:last-child)": {
        marginBottom: theme.spacing.technicalDetail.margin.bottom.stampTimeItem,
      },
    },
  },

  alert: {
    padding: theme.spacing.technicalDetail.alert.padding,
    marginBottom: theme.spacing.technicalDetail.alert.marginBottom,
    background: "none",
  },
  technicalBlock: {
    maxWidth: theme.spacing.technicalDetail.width.max,
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: theme.spacing.technicalDetail.padding.block.left,
    paddingRight: theme.spacing.technicalDetail.padding.block.right,
    paddingTop: theme.spacing.technicalDetail.padding.block.top,
    ".mantine-Accordion-item, .mantine-Accordion-control": {
      backgroundColor: theme.customBackgrounds.white,
    },
    ".show-hide": {
      paddingLeft: theme.spacing.technicalDetail.padding.showHide.left,
      color: theme.customColors.black,
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
}));
